export default __webpack_public_path__ + "static/media/Aryan Sharma.a4d04eab.jpeg";